export const filterActionTypes = {
  filterByLetter: '[ABC Filter] - filter by letter button click',
  resetFilters: '[Card Filter] - reset filters',
  manageFilter: '[Manage Filter] - manage filters',
  deleteFilter: '[Manage Filter] - delete filter',
};
